import { LogoutRequest, LogoutResponse } from '../logout';
import * as _m0 from "protobufjs/minimal";
import { getServiceUrl } from '../utils/api';

export async function logout(): Promise<LogoutResponse> {
    const request: LogoutRequest = {};
    const encodedRequest = LogoutRequest.encode(request).finish();
    const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

    const url = getServiceUrl('authservice', 'logout');

    const response = await fetch(
        url, {
        method: 'POST',
        credentials: 'include', // Necessary to send the HttpOnly cookie
        body: base64
    }
    );

    if (response.status !== 200) {
        throw new Error(`Unable to logout! Status: ${response.status}`);
    }

    const encodedByteString = await response.text();
    const decodedByteString = atob(encodedByteString);
    const decodedBytes = new Uint8Array(decodedByteString.length);
    for (let i = 0; i < decodedByteString.length; i++) {
        decodedBytes[i] = decodedByteString.charCodeAt(i);
    }

    return LogoutResponse.decode(decodedBytes);
}
